import {Component, OnInit, EventEmitter} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {ModulesService} from '../../../_services/modules.service';
import {ModulesModel} from '../../../_models/modules'
import {Observable} from "rxjs/Observable";
import {LineBotService} from '../../../_services/line-bot.service';
import {TelegramChannelService} from '../../../_services/telegram-channel.service';
import {PopupShowListCoinComponent} from "../../send-signal-event/popup-show-list-coin/popup-show-list-coin.component";
import {SendSignalService} from "../../../_services/send-signal.service";

@Component({
    selector: 'app-add-modules',
    templateUrl: './show-modules.component.html',
    styleUrls: ['./show-modules.component.css']
})

export class ShowModulesComponent extends DialogComponent<ModulesModel, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string;
    focusEventEmitter = new EventEmitter<boolean>();
    modulesAlls: any = [];
    lineBotAlls: Observable<any[]>;
    telegramAlls: Observable<any[]>;
    objPopUp: any;

    constructor(
        dialogService: DialogService,
        private modulesService: ModulesService,
        private lineBotService: LineBotService,
        private telegramChannelService: TelegramChannelService,
        private sendSignalService: SendSignalService) {
        super(dialogService);
    }

    ngOnInit() {
        this.modulesService.getAllModuleAndFeatureModuleWeb().subscribe(res => {
            this.modulesAlls = res;
        });
        this.lineBotAlls =  this.lineBotService.getLineBotAlls();
        this.telegramAlls = this.telegramChannelService.getTelegramAll();
    }

    ngAfterViewInit() {
        let self = this;
        setTimeout(() => {
            self.focusEventEmitter.emit(true);
        });
    }

    openModalShowCoinPriceForUser(codeSendSignalEvent: any) {
        let self = this;
        this.sendSignalService.postListCoinNameActive({codeSendSignalEvent: codeSendSignalEvent}).subscribe((resListCoinName: Response) => {
            self.objPopUp = {
                titlePopup: 'ユーザーにプライスを送信するコインの表示',
                listCoinSendSignal: resListCoinName,
            };
            this.dialogService.addDialog(PopupShowListCoinComponent, self.objPopUp).subscribe((isAccess) => {
            });
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/register/show-modules/show-modules.component.ts